import React from 'react';
import { InputGroupAddon } from 'reactstrap';
import { useClickToCallOnPhoneField } from '../../hooks/useClickToCallOnPhoneField';
import { ActionInputButton } from 'components/FlexControllerInput/components/styles';
import { useSelector } from 'react-redux';
import { FaPhone } from 'react-icons/fa6';

export const InputWithButtonCall = ({ phoneValue, phoneDDI }) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { canMakeCall, makeCall } = useClickToCallOnPhoneField();
  return (
    <InputGroupAddon addonType="append">
      <ActionInputButton
        primaryColor={systemConfiguration.primary_color}
        disabled={!canMakeCall(phoneValue, phoneDDI)}
        onClick={() => makeCall(phoneValue)}
      >
        <FaPhone size={12} />
      </ActionInputButton>
    </InputGroupAddon>
  );
};
